import React from 'react'
import T from 'prop-types'
import { Box } from '@mui/material'

import airLogo from '../../assets/images/logo-air.png'

export default function AirIcon({ sx, fontSize = 'small', ...props }) {
  const sizeMap = {
    small: 14,
    medium: 20,
    large: 28,
    inherit: '1em',
  }
  const size = sizeMap[fontSize] ?? fontSize

  return (
    <Box
      component="img"
      src={airLogo}
      alt="Air"
      sx={{ height: size, width: 'auto', ...sx }}
      {...props}
    />
  )
}

AirIcon.propTypes = {
  fontSize: T.oneOfType([
    T.oneOf(['small', 'medium', 'large', 'inherit']),
    T.number,
  ]),
  sx: T.object,
}
